import React, { Fragment } from 'react';
import { Heading } from 'roo-ui/components';
import { useSelector } from 'react-redux';
import { themeGet } from 'styled-system';
import TruncateText from 'components/TruncateText';
import { getProperty } from 'store/booking/bookingSelectors';
import { useDataLayer } from 'hooks/useDataLayer';

const PropertyDescription = () => {
  const property = useSelector(getProperty);
  const { emitInteractionEvent } = useDataLayer();
  const { description, name } = property;

  const headingText = `About ${name}`;

  const onClickReadMoreCallback = () => {
    emitInteractionEvent({ type: 'About Property More Link', value: 'Read More Link Selected' });
  };

  return (
    <Fragment>
      <Heading.h3 fontSize={['base', 'md']} mb={4} data-testid="property_name">
        {headingText}
      </Heading.h3>
      <TruncateText
        text={description}
        fontSize={['sm', 'base']}
        isTruncated
        background={themeGet('colors.gradients.transparentToGrey')}
        modalTitle={headingText}
        data-testid="property_description"
        onClickReadMoreCallback={onClickReadMoreCallback}
      />
    </Fragment>
  );
};

export default PropertyDescription;
